import { createApp } from 'vue'
import App from './App.vue'
// import vueDirectiveTooltip from 'vue-directive-tooltip';
// import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
// import Resource from "vue-resource";

// Vue.use(vueDirectiveTooltip);
import './assets/css/semantic.css';
// Vue.config.productionTip = false
const app = createApp(App);
// app.use(vueDirectiveTooltip);
// app.use(Resource);
app.mount('#sidebar')
// new Vue({
//   render: h => h(App),
// }).$mount('#sidebar')


